exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-footer-modal[data-v-11b14f26] {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.btn-footer-modal .btn[data-v-11b14f26]:first-child {\n    margin-right: 15px;\n}\n", ""]);

// exports
